import AlContactSelectorController from './controller';
import templateUrl from './component.tpl.html';

angular.module('festzelt-os.modules.contacts')
.component(
    'alContactSelector',
    {
        controller: AlContactSelectorController,
        controllerAs: 'vm',
        bindings: {
            scopedGuestlists: '<',
            onContactSelect: '&'
        },
        templateUrl
    }
)



// WEBPACK FOOTER //
// ./src/app/modules/contacts/components/al-contact-selector/component.js